import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AdminAuthenticationService } from 'src/app/services/admin-authentication.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-admin-login',
  standalone: false,
  templateUrl: './admin-login.component.html',
  styleUrl: './admin-login.component.scss',
})
export class AdminLoginComponent {
  password = '';
  loginError = false;

  @Output()
  loginSuccess = new EventEmitter<void>();

  constructor(
    private adminAuthenticationService: 
      AdminAuthenticationService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  login(): void {
    this.loginError = false;

    this.loadingService.load(
      this.adminAuthenticationService.login(this.password)
    ).subscribe({
      next: () => {
        this.password = '';
        this.loginSuccess.emit();
      },
      error: () => {
        this.loginError = true;

        this.toastrService.error(
          this.translateService.instant(
            'ADMINISTRATION.INVALID-PASSWORD'
          )
        );
      }
    });
  }
}
